const mutations = {
  set_status(state, status) {
    state.status = status;
  },
  set_corpId(state, id) {
    state.corpId = id;
  },
  set_channelInfo(state, info) {
    state.channelInfo = info;
  },
  set_menuList(state, list) {
    state.menuList = list;
  },
  set_playerInfo(state, info) {
    state.playerInfo = info;
  },
  set_wechatInfo(state, info) {
    state.wechatInfo = info;
  },
  set_userInfo(state, info) {
    state.userInfo = info;
  },
  set_uuid(state, info) {
    state.uuid = info;
  },
  set_playAddress(state, url) {
    state.playerAddress = url;
  },
  set_globalSetting(state, info) {
    state.globalSetting = info
  },
  set_isDMSLinked(state, bool) {
    state.isDMSLinked = bool
  },
  set_drainage(state, info) {
    state.drainage = info || {}
  },
  set_drainage_state(state, info) {
    state.drainage = {
      ...state.drainage,
      drainage_status: info,
    }
  },
  set_drainage_counter(state, info) {
    state.drainage = {
      ...state.drainage,
      drainage_counter: info,
    }
  },
};
export default mutations;
